export const OFFICE_ACTIONS_DATA = [
  {
    rank: 1,
    code: 'CTNF' as const,
    description: 'Non-Final Rejection',
    frequency: 7_717_229,
    category: 'EX',
    details:
      'Following the search of prior art, an office action to applicant may include a rejection of one or more claims and does not close out prosecution; the Examiner may receive a count for the non-final rejection.',
  },
  {
    rank: 2,
    code: 'CTFR' as const,
    description: 'Final Rejection',
    frequency: 3_160_574,
    category: 'EX',
    details:
      "Any second or any subsequent actions on the merits from the Examiner may be made final (i.e. final rejection), except where the Examiner introduces a new ground of rejection that is neither necessitated by applicant's amendment of the claims nor based on information submitted in an information disclosure.",
  },
  {
    rank: 3,
    code: 'CTRS' as const,
    description: 'Restriction/Election Requirement',
    frequency: 1_239_241,
    category: 'EX',
    details:
      'Restriction is a generic term that includes the practice of requiring an election between distinct inventions, for example, election between combination and sub-combination inventions, and the practice relating to an election between independent inventions, for example, an election of species. An Examiner may make a restriction requirement when an application may properly support separate patents and they are either independent or distinct.',
  },
  {
    rank: 4,
    code: 'DOCK' as const,
    description: 'Case Docketed to Examiner in GAU',
    frequency: 16_264_663,
    category: 'EX',
    details:
      'Indicates that a case has been docketed to a patent examiner and is ready for initial examination by that examiner. Once docketed, cases are examined in the order determined by docket management practices.',
  },
  {
    rank: 5,
    code: 'FWDX' as const,
    description: 'Date Forwarded to Examiner',
    frequency: 11_923_609,
    category: 'EX',
    details:
      "Indicates that a case is ready for action by the examiner. Different from DOCK in that the application is returning to one of the examiner's amended dockets, typically following an applicant response.",
  },
  {
    rank: 6,
    code: 'WIDS' as const,
    description: 'Information Disclosure Statement (IDS) Filed',
    frequency: 9_626_527,
    category: 'AA',
    details:
      "Indicates that an Information Disclosure Statement (IDS) has been filed by the patent applicant. An IDS is typically filed in order to satisfy an applicant's duty of disclosure (37 CFR 1.56). The mechanics and content of the filing are governed by 37 CFR 1.97 and 1.98.",
  },
  {
    rank: 7,
    code: 'MCTNF' as const,
    description: 'Mail Non-Final Rejection',
    frequency: 7_669_612,
    category: 'EX',
    details:
      'Indicates that the Office mailed a non-final rejection to the applicant.',
  },
  {
    rank: 8,
    code: 'M844' as const,
    description: 'Information Disclosure Statement (IDS) Filed',
    frequency: 7_395_622,
    category: 'AA',
    details:
      "Indicates that an Information Disclosure Statement (IDS) has been filed by the patent applicant. An IDS is typically filed in order to satisfy an applicant's duty of disclosure (37 CFR 1.56). The mechanics and content of the filing are governed by 37 CFR 1.97 and 1.98.",
  },
  {
    rank: 9,
    code: 'IEXX' as const,
    description: 'Initial Exam Team nn',
    frequency: 7_159_769,
    category: 'PE',
    details:
      'Typically the first code and sets status to 19 ("Application Undergoing Preexam Processing"). Indicates that initial processing has been performed on the application.',
  },
  {
    rank: 10,
    code: 'A...' as const,
    description: 'Response after Non-Final Action',
    frequency: 6_842_372,
    category: 'AA',
    details:
      'Amendment filed by the applicant in response to a non-final office action issued by the Examiner based on the merits of the application. Document may be included in AS FILED.',
  },
  {
    rank: 11,
    code: 'SCAN' as const,
    description: 'IFW Scan & PACR Auto Security Review',
    frequency: 6_315_420,
    category: 'PE',
    details:
      'Indicates that the application was scanned into the Image File Wrapper (IFW) database of patent application images.',
  },
  {
    rank: 12,
    code: 'OIPE' as const,
    description: 'Application Dispatched from OIPE',
    frequency: 6_231_909,
    category: 'PE',
    details:
      'Indicates that the application has left the Office of Patent Application Processing (OPAP, formerly Office of Initial Patent Examination or OIPE). Indicates some level of completeness of the application.',
  },
  {
    rank: 13,
    code: 'EML_NTR' as const,
    description: 'Email Notification',
    frequency: 5_951_620,
    category: 'AD',
    details:
      'Indicates that applicant has been sent an email notification that new outgoing correspondence is available for viewing in PAIR.',
  },
  {
    rank: 14,
    code: 'IDSC' as const,
    description: 'Information Disclosure Statement considered',
    frequency: 5_934_848,
    category: 'EX',
    details:
      'Indicates that an Information Disclosure Statement (IDS) has been considered by an examiner. There is one code entered per IDS, so multiple IDSs will result in multiple entries of the code.',
  },
  {
    rank: 15,
    code: 'N/=.' as const,
    description: 'Notice of Allowance Data Verification Completed',
    frequency: 5_522_092,
    category: 'EX',
    details: 'Indicates that the claims in the application have been allowed.',
  },
  {
    rank: 16,
    code: 'MN/=.' as const,
    description: 'Mail Notice of Allowance',
    frequency: 5_519_622,
    category: 'EX',
    details:
      'Indicates that applicant has been mailed a notice of allowance. Sets application status to 92 ("Allowed -- Notice of Allowance Mailed -- Issue Revision Completed").',
  },
  {
    rank: 17,
    code: 'N084' as const,
    description: 'Issue Fee Payment Verified',
    frequency: 5_284_754,
    category: 'ISS',
    details: '',
  },
  {
    rank: 18,
    code: 'COMP' as const,
    description: 'Application Is Now Complete',
    frequency: 5_094_357,
    category: 'PE',
    details:
      'Indicates that the specification, drawings (if necessary), etc., have been received.',
  },
  {
    rank: 19,
    code: 'PGM/' as const,
    description: 'Recordation of Patent Grant Mailed',
    frequency: 4_848_790,
    category: 'ISS',
    details:
      'Indicates that the bond paper copy of the patent grant has been ribboned, sealed, and mailed by the Office of Patent Publication.',
  },
  {
    rank: 20,
    code: 'L194' as const,
    description: 'Cleared by OIPE CSR',
    frequency: 4_609_481,
    category: 'PE',
    details:
      'Indicates that the application has been cleared by Classification Security Review (CSR) in OIPE (Office of Initial Patent Examination--now OPAP or Office of Patent Application Processing)',
  },
  {
    rank: 21,
    code: 'WPIR' as const,
    description: 'Issue Notification Mailed',
    frequency: 4_574_633,
    category: 'ISS',
    details:
      'The patent number and issue date are determined approximately 10 days prior to the patent issuing. After the patent number and issue date are determined. the Office mails an Issue Notification to the applicant. The Issue Notification contains the patent number and issue date. The process of determining the patent number and issue date was changed significantly in 1999. Prior to this change, the patent number and issue date were determined before electronic capture of the data to appear on the patent. If any unclear data was found during electronic data capture, this process could result in the issue date being missed. The current process resolves those issues prior to mailing of the Issue Notification.',
  },
  {
    rank: 22,
    code: 'EML_NTF' as const,
    description: 'Email Notification',
    frequency: 4_211_906,
    category: 'AD',
    details:
      'Indicates that applicant has been sent an email notification that new outgoing correspondence is available for viewing in PAIR.',
  },
  {
    rank: 23,
    code: 'XT/G' as const,
    description: 'Request for Extension of Time - Granted',
    frequency: 4_093_668,
    category: 'EX',
    details:
      'By statute, applicants must respond to examiner office actions within 6 months. If they reply between the end of the 3rd month and the end of the 6th month, they must request an extension of time.',
  },
  {
    rank: 24,
    code: 'ELC_RVW' as const,
    description: 'Electronic Review',
    frequency: 4_065_488,
    category: 'UC',
    details: '',
  },
  {
    rank: 25,
    code: 'RCAP' as const,
    description: 'Reference capture on IDS',
    frequency: 3_458_357,
    category: 'UC',
    details: 'Indicator of an IDS filing.',
  },
  {
    rank: 26,
    code: 'PILS' as const,
    description: 'Application Is Considered Ready for Issue',
    frequency: 3_332_985,
    category: 'ISS',
    details:
      'An indicator that all requirements have been met for the application to issue as a patent.',
  },
  {
    rank: 27,
    code: 'MCTFR' as const,
    description: 'Mail Final Rejection (PTOL - 326)',
    frequency: 3_156_370,
    category: 'EX',
    details:
      'Indicates that a final rejection has been mailed in the application. This typically follows a response (A…) to a non-final rejection (MCTNF), though it is possible in rare circumstances for a final rejection to occur without a non-final rejection having occurred (see MPEP 706.07(b) regarding first action final rejections). A final rejection closes prosecution in an application where at least one of the claims has been found by the examiner to be unpatentable.',
  },
  {
    rank: 28,
    code: 'IFEE' as const,
    description: 'Issue Fee Payment Received',
    frequency: 2_918_079,
    category: 'ISS',
    details:
      'Indicates that the Office has received the issue fee from applicant. This sets the application status to 94 ("Publications -- Issue Fee Payment Received"). The issue fee varies based on the size of the entity applying for the patent. As of January 2014, the issue fee ranged from $240 for a micro-entity to $960 for a large entity. See 37 CFR 1.18(a)(1) for the current utility patent issue fees.',
  },
  {
    rank: 29,
    code: 'FLRCPT.O' as const,
    description: 'Filing Receipt',
    frequency: 2_876_702,
    category: 'PE',
    details: 'Indicates that a filing receipt has been generated.',
  },
  {
    rank: 30,
    code: 'R1021' as const,
    description: 'Receipt into Pubs',
    frequency: 2_723_657,
    category: 'UC',
    details: '',
  },
  {
    rank: 31,
    code: 'D1935' as const,
    description: 'Dispatch to FDC',
    frequency: 2_715_910,
    category: 'UC',
    details:
      'Dispatch to the Final Data Capture processing center for printing and final issue preparation',
  },
  {
    rank: 32,
    code: 'PTAC' as const,
    description: 'Patent Issue Date Used in PTA Calculation',
    frequency: 2_675_276,
    category: 'AD',
    details:
      'Indicates that the PTA calculation has been made. Also indicates that the application has been assigned a patent number and issue date.',
  },
  {
    rank: 33,
    code: 'PG-ISSUE' as const,
    description: 'PG-Pub Issue Notification',
    frequency: 2_668_448,
    category: 'AD',
    details:
      'Indicates that the Pre-Grant Publication (PG-Pub) of the application has been published. This is also a point at which an application becomes available in publicly viewable.',
  },
  {
    rank: 34,
    code: 'C.AD' as const,
    description: 'Correspondence Address Change',
    frequency: 2_612_289,
    category: 'AA',
    details:
      'Applicant has submitted a request to change the correspondence address or the Office has entered a requested change to the correspondence address. The Office will send all notices, official letters, and other communications relating to the application to the person associated with the correspondence address. An applicant may also designate a maintenance fee address different from the correspondence address. All maintenance fee communicatons will be sent to this fee address. Effective February 11, 2014, maintenance fee address changes will generate an MFEE.C.AD code. Note that during 2000-2001, a large number of previously-filed correspondence address changes were entered into the system.',
  },
  {
    rank: 35,
    code: 'A.PE' as const,
    description: 'Preliminary Amendment',
    frequency: 2_325_115,
    category: 'AA',
    details:
      'A preliminary amendment has been filed in the application. A preliminary amendment is an amendment that is received in the Office on or before the mail date of the first Office action. If present on the filing date of the application, it is treated as part of the original disclosure of the application.',
  },
  {
    rank: 36,
    code: 'TSSCOMP' as const,
    description: 'IFW TSS Processing by Tech Center Complete',
    frequency: 2_247_912,
    category: 'UC',
    details: 'Image File Wrapper Processing by Technology Support Staff (TSS)',
  },
  {
    rank: 37,
    code: 'PGPC' as const,
    description: 'Sent to Classification Contractor',
    frequency: 2_155_104,
    category: 'PE',
    details:
      'Indicates that the application has been sent to the contractor responsible for assigning the classification(s) of the application. This classification is necessary in order to route the application to the appropriate Technology Center (TC) within the USPTO. This sets the status of the application to 17 ("Sent to Classification contractor").',
  },
  {
    rank: 38,
    code: 'RQPR' as const,
    description: 'Request for Foreign Priority',
    frequency: 2_119_299,
    category: 'AA',
    details:
      'Applicant may provide priority papers to support a request for foreign priority.',
  },
  {
    rank: 39,
    code: 'DVER' as const,
    description: 'Document Verification',
    frequency: 2_101_203,
    category: 'UC',
    details:
      'A Notice of Allowance, for example, must go through document verification.',
  },
  {
    rank: 40,
    code: 'PA..' as const,
    description: 'Change in Power of Attorney (May Include Associate POA)',
    frequency: 1_936_106,
    category: 'AA',
    details:
      'Applicant submitted a Power of Attorney document. Applicant may file a change in Power of Attorney at any time during prosecution of an application. The POA indicates representatives given permission to act on behalf of the inventor or assignee to prosecute an application. Applicant may name as representative any of the following three: (1) one or more joint inventors of the application, (2) the registered patent practitioners associated with a customer number, or (3) ten or fewer individually listed registered patent practitioners. Regarding associate power of attorney, the practice of associate power of attorney was eliminated by the USPTO effective June 25, 2004. It was supplanted by the use of customer numbers.',
  },
  {
    rank: 41,
    code: 'A.NE' as const,
    description: 'Response after Final Action',
    frequency: 1_868_843,
    category: 'AA',
    details:
      'Amendment provided by the applicant after the Examiner closes prosecution with a final rejection. Amendment is not automatically entered by the Examiner. It will not be entered if it requires additional search or more than cursory review.',
  },
  {
    rank: 42,
    code: 'EIDS.' as const,
    description: 'Electronic Information Disclosure Statement',
    frequency: 1_755_375,
    category: 'AA',
    details: 'Applicant submitted an electronic IDS.',
  },
  {
    rank: 43,
    code: 'INCD' as const,
    description: 'Notice Mailed--Application Incomplete--Filing Date Assigned',
    frequency: 1_682_045,
    category: 'PE',
    details:
      'Notice is mailed indicating that a necessary part of the application is missing.',
  },
  {
    rank: 44,
    code: 'EX.A' as const,
    description: "Examiner's Amendment Communication",
    frequency: 1_511_110,
    category: 'EX',
    details:
      'The examiner amended the application and that amendment has been processed. Typically, this is done in order to bring the application into condition for allowance and is documented in a Notice of Allowance.',
  },
  {
    rank: 45,
    code: 'BRCE' as const,
    description: 'Workflow - Request for RCE - Begin',
    frequency: 1_398_129,
    category: 'AD',
    details: 'See RCEX below',
  },
  {
    rank: 46,
    code: 'ABN9' as const,
    description: 'Disposal for a RCE / CPA / R129',
    frequency: 1_394_052,
    category: 'AD',
    details: 'See RCEX below',
  },
  {
    rank: 47,
    code: 'RCEX' as const,
    description: 'Request for Continued Examination (RCE)',
    frequency: 1_391_929,
    category: 'AA',
    details:
      'Applicant filed a request for continued examination (RCE). If prosecution in an application is closed, an applicant may request continued examination (RCE) of the application by filing a submission and the fee prior to payment of the issue fee, abandonment of the application, or the filing of a notice of appeal. A submission includes, but is not limited to, an information disclosure statement, an amendment to the written description, claims, or drawings, new arguments, or new evidence in support of patentability. The USPTO will withdraw the finality of any Office action and the submission will be entered and considered. This typically occurs at some point after the application has been finally rejected (MCTFR). Currently, an RCE causes the status to change to 30 ("Docketed New Case - Ready for Examination"). Prior to November 2009, an RCE caused the status to change to 71 ("Response to Non-Final Office Action Entered and Forwarded to Examiner").',
  },
  {
    rank: 48,
    code: 'ADDFLFEE' as const,
    description: 'Additional Application Filing Fees',
    frequency: 1_383_459,
    category: 'PE',
    details: '',
  },
  {
    rank: 49,
    code: 'EXIN' as const,
    description: 'Examiner Interview Summary Record (PTOL - 413)',
    frequency: 1_268_286,
    category: 'EX',
    details:
      'When an Examiner conducts an interview with applicant, the Examiner summarizes the record of that interview including any agreements reached in an Examiner Interview Summary Record.',
  },
  {
    rank: 50,
    code: 'FILM' as const,
    description: 'Application Captured on Microfilm',
    frequency: 1_260_466,
    category: 'PE',
    details: '',
  },
  {
    rank: 51,
    code: 'SENT' as const,
    description: 'Workflow - File Sent to Contractor',
    frequency: 1_248_651,
    category: 'AD',
    details: '',
  },
  {
    rank: 52,
    code: 'MCTRS' as const,
    description: 'Mail Restriction Requirement',
    frequency: 1_237_868,
    category: 'EX',
    details:
      'A restriction requirement and/or election of species has been mailed to the applicant. This requires the applicant to elect an invention and/or species. If the application contains claims to multiple independent or distinct inventions and examination of these multiple inventions would be burdensome, the examiner may require the applicant to elect an invention to be examined.',
  },
  {
    rank: 53,
    code: 'ABN2' as const,
    description: 'Aband. for Failure to Respond to O. A.',
    frequency: 1_232_313,
    category: 'ABN',
    details:
      "The application is considered abandoned because the applicant did not respond to the examiner's office action within 6 months.",
  },
  {
    rank: 54,
    code: 'OATHDECL' as const,
    description:
      'A statement by one or more inventors satisfying the requirement under 35 USC 115, Oath of the Applic',
    frequency: 1_230_787,
    category: 'PE',
    details: '',
  },
  {
    rank: 55,
    code: 'MABN2' as const,
    description: 'Mail Abandonment for Failure to Respond to Office Action',
    frequency: 1_227_860,
    category: 'ABN',
    details:
      'A notice is mailed to the applicant stating that the application has been abandoned due to failure to respond to an office action.',
  },
  {
    rank: 56,
    code: 'ROIPE' as const,
    description: 'Application Return TO OIPE',
    frequency: 1_205_580,
    category: 'PE',
    details: 'OIPE is the Office for Initial Patent Examination',
  },
  {
    rank: 57,
    code: 'WROIPE' as const,
    description: 'Application Return from OIPE',
    frequency: 1_202_853,
    category: 'PE',
    details: 'OIPE is the Office for Initial Patent Examination',
  },
  {
    rank: 58,
    code: 'ELC.' as const,
    description: 'Response to Election / Restriction Filed',
    frequency: 1_166_428,
    category: 'AA',
    details:
      "Restriction is a generic term that includes the practice of requiring an election between distinct inventions, for example, election between combination and sub-combination inventions, and the practice relating to an election between independent inventions, for example, an election of species. An Examiner may make a restriction requirement when an application may properly support separate patents and they are either independent or distinct. The Examiner may make this request either over the telephone, in which case the applicant's response is recorded in the next Office action, or in a separate letter making the Election or Restriction requirement. In the latter case, the applicant responds to this requirement in a separate response electing an invention or species to be examined.",
  },
  {
    rank: 59,
    code: 'TI1050' as const,
    description: 'Transfer Inquiry to GAU',
    frequency: 1_149_392,
    category: 'PE',
    details:
      'Transfer inquiries can be initiated when a case has been docketed to an incorrect art unit or when an un-docketed new case is assigned an incorrect classification.',
  },
  {
    rank: 60,
    code: 'CTAV' as const,
    description: 'Advisory Action (PTOL-303)',
    frequency: 1_121_270,
    category: 'EX',
    details:
      'Applicant may submit an amendment in an application after the Examiner has closed out prosecution with a final rejection. The amendment is not automatically entered by the Examiner. If the amendment does not place the application in condition for allowance, the Examiner will send the applicant an advisory action noting whether the proposed amendment will be entered or not, and if not, why it will not be entered. The Examiner also notes to applicant the status of the claims.',
  },
  {
    rank: 61,
    code: 'MCTAV' as const,
    description: 'Mail Advisory Action (PTOL - 303)',
    frequency: 1_119_956,
    category: 'EX',
    details: 'Advisory action mailed to the applicant. See CTAV above.',
  },
  {
    rank: 62,
    code: 'MEX.A' as const,
    description: "Mail Examiner's Amendment",
    frequency: 1_064_164,
    category: 'EX',
    details:
      'The examiner amended the application and this amendment was mailed or otherwise delivered to the applicant. Typically, this is done in order to bring the application into condition for allowance and is documented in a Notice of Allowance.',
  },
  {
    rank: 63,
    code: 'DRWF' as const,
    description: 'Workflow - Drawings Finished',
    frequency: 1_015_546,
    category: 'AD',
    details: '',
  },
  {
    rank: 64,
    code: 'LET.' as const,
    description: 'Miscellaneous Incoming Letter',
    frequency: 957_696,
    category: 'AA',
    details:
      'A miscellaneous incoming letter from applicant shall be submitted any time during prosecution that is not directed to a requirement, notice or Office action sent by the USPTO. Document may be included in AS FILED.',
  },
  {
    rank: 65,
    code: 'EXP.' as const,
    description: 'Expire Patent',
    frequency: 941_231,
    category: 'AD',
    details: '',
  },
  {
    rank: 66,
    code: 'C.ADB' as const,
    description: 'Correspondence Address Change',
    frequency: 909_044,
    category: 'AA',
    details: 'Analogous to C.AD above.',
  },
  {
    rank: 67,
    code: 'SETS' as const,
    description: 'Set Application Status',
    frequency: 858_558,
    category: 'AD',
    details:
      'A code primarily used for older applications that have been added to Public PAIR.',
  },
  {
    rank: 68,
    code: 'M903' as const,
    description: 'Notice of DO/EO Acceptance Mailed',
    frequency: 827_735,
    category: 'PE',
    details:
      "The USPTO sends a Notice to applicant of the acceptance of their application by the USPTO as a Designated Office or Elected Office when applicant's international application has met all of the criteria for becoming a US national stage application and is accepted for national patentability examination in the USPTO.",
  },
  {
    rank: 69,
    code: 'RCDT' as const,
    description: 'Receipt Date',
    frequency: 813_610,
    category: 'UC',
    details: '',
  },
  {
    rank: 70,
    code: 'MLIB' as const,
    description: 'Record Copy Mailed',
    frequency: 809_049,
    category: 'UC',
    details: '',
  },
  {
    rank: 71,
    code: 'DRWM' as const,
    description: 'Workflow - Drawings Matched with File at Contractor',
    frequency: 791_997,
    category: 'AD',
    details: '',
  },
  {
    rank: 72,
    code: 'C614' as const,
    description: 'New or Additional Drawing Filed',
    frequency: 787_444,
    category: 'AA',
    details:
      'The applicant has filed a new drawing to accompany the application.',
  },
  {
    rank: 73,
    code: 'FLRCPT.U' as const,
    description: 'Filing Receipt - Updated',
    frequency: 758_856,
    category: 'PE',
    details: 'Indicates that a filing receipt has been updated.',
  },
  {
    rank: 74,
    code: 'EXPRO' as const,
    description: 'EXPIRED PROVISIONAL',
    frequency: 753_665,
    category: 'AD',
    details:
      'Code indicates that a provisional application has expired after 12 months.',
  },
  {
    rank: 75,
    code: 'EX.R' as const,
    description: 'Reasons for Allowance',
    frequency: 709_881,
    category: 'EX',
    details: 'Another indicator of allowance.',
  },
  {
    rank: 76,
    code: 'PET.' as const,
    description: 'Petition Entered',
    frequency: 685_076,
    category: 'AA',
    details:
      'Any incoming petition from applicant shall include all petition attachments submitted during prosecution of an application that is entered/scanned into the file.',
  },
  {
    rank: 77,
    code: 'P102' as const,
    description: 'Notification Concerning Payment of Fees',
    frequency: 652_795,
    category: 'PCT',
    details:
      'The form PCT/RO/102 is generated for every new international application. It provides the applicant with an explanation of all required fees, how much money has been collected for each fee and whether any addition money is due.',
  },
  {
    rank: 78,
    code: 'L198' as const,
    description: 'Referred to Level 2 (LARS) by OIPE CSR',
    frequency: 644_663,
    category: 'PE',
    details:
      'License and Review (L&R / LAR) determine whether an application will not be published because publication or disclosure of the application would be detrimental to national security.',
  },
  {
    rank: 79,
    code: '371COMP' as const,
    description: '371 Completion Date',
    frequency: 641_222,
    category: 'PE',
    details:
      'Indicator of national stage entry of existing Patent Cooperation Treaty (PCT) application. Effective filing date of resulting regular application.',
  },
  {
    rank: 80,
    code: 'P105' as const,
    description: 'Notification of Intntl. Appl. Number and Intntl. Filing Date',
    frequency: 615_448,
    category: 'PCT',
    details:
      'The form PCT/RO/105 is akin to a filing receipt for an international application.',
  },
  {
    rank: 81,
    code: 'APPERMS' as const,
    description:
      'Applicants have given acceptable permission for participating foreign',
    frequency: 586_154,
    category: 'UC',
    details:
      'The Priority Document Exchange (PDX) program enables electronic exchange of certified priority documents between the USPTO, EPO, JPO, and KIPO.',
  },
  {
    rank: 82,
    code: 'L128' as const,
    description: 'Cleared by L&R (LARS)',
    frequency: 584_474,
    category: 'PE',
    details:
      'License and Review (L&R) determine whether an application will not be published because publication or disclosure of the application would be detrimental to national security.',
  },
  {
    rank: 83,
    code: 'N423' as const,
    description: 'Post Issue Communication - Certificate of Correction',
    frequency: 548_369,
    category: 'ISS',
    details:
      'Usually to correct minor mistakes that do not affect the scope of the claims.',
  },
  {
    rank: 84,
    code: 'DRWI' as const,
    description: 'Workflow - Drawings Received at Contractor',
    frequency: 524_486,
    category: 'AD',
    details: '',
  },
  {
    rank: 85,
    code: 'N/AP' as const,
    description: 'Notice of Appeal Filed',
    frequency: 511_996,
    category: 'AA',
    details:
      "Applicant filed a Notice of Appeal. After two rejections from the Examiner, an applicant may file a Notice of Appeal noting that applicant (now appellant) is appealing the Examiner's decision. The appeal is to be decided upon by an administrative patent judge from the Patent Board within the USPTO. The judge weighs the evidence in the Appeal Brief and in an Examiner's Answer to reach a decision.",
  },
  {
    rank: 86,
    code: 'DIST' as const,
    description: 'Terminal Disclaimer Filed',
    frequency: 498_287,
    category: 'AA',
    details:
      'Applicant filed a terminal disclaimer. A timely filed terminal disclaimer may be filed by applicant to overcome an actual or provisional rejection based on a nonstatutory double patenting ground provided the conflicting application or patent is shown to be commonly owned with this application. The purpose of a terminal disclaimer is to obviate a double patenting rejection by removing the potential harm to the public by issuing a second patent, and not to remove a patent as prior art. (For example: PTO/SB/25 or PTO/SB/26)',
  },
  {
    rank: 87,
    code: 'M327' as const,
    description: 'Miscellaneous Communication to Applicant - No Action Count',
    frequency: 479_673,
    category: 'EX',
    details:
      'Any communication from the USPTO to applicant that does not fit into any other doc code may be designated as a miscellaneous communication. Those communications that an Examiner would not receive an action count for would include such communications as supplying a missing page from an Office action or clarifying an action taken at an interview.',
  },
  {
    rank: 88,
    code: 'MM327' as const,
    description: 'Mail Miscellaneous Communication to Applicant',
    frequency: 479_413,
    category: 'EX',
    details: 'Mailing of a miscellaneous communication. See M327 above.',
  },
  {
    rank: 89,
    code: 'D1220' as const,
    description: 'Dispatch to Publications',
    frequency: 471_184,
    category: 'AD',
    details: '',
  },
  {
    rank: 90,
    code: 'TR.Q' as const,
    description: 'Transfer Inquiry',
    frequency: 455_642,
    category: 'PE',
    details:
      'Transfer inquiries can be initiated when a case has been docketed to an incorrect art unit or when an undocketed new case is assigned an incorrect classification.',
  },
  {
    rank: 91,
    code: 'MEXIN' as const,
    description: 'Mail Examiner Interview Summary (PTOL - 413)',
    frequency: 437_260,
    category: 'EX',
    details:
      'The Office mailed an interview summary form (PTOL-413) to the applicant. This can be its own mailing or an attachment to another Office action. This code was introduced in 2001. More specific codes indicating whether the interview was applicant-initiated or examiner-initiated, telephonic, in-person, or a video conference were introduced starting in 2011. Consequently, use of this code has decreased after peaking at 85,679 occurrences in 2010.',
  },
  {
    rank: 92,
    code: 'PDREQUST' as const,
    description:
      'Request from applicant for the USPTO to retrieve the Priority Document',
    frequency: 427_016,
    category: 'AA',
    details:
      'Request from the applicant authorizing the USPTO to electronically retrieve Official Priority Documents from participating foreign IP Office and enter them into the file wrapper.',
  },
  {
    rank: 93,
    code: 'FTFI' as const,
    description: 'FITF set to NO - revise initial setting',
    frequency: 425_947,
    category: 'PE',
    details:
      'First inventor to file indicator is set to NO. The value of the FITF indicator determines which prior-art framework will be applied to the application during examination. (If NO then pre-AIA. If YES, then the AIA provisions apply.)',
  },
  {
    rank: 94,
    code: 'TCPB' as const,
    description: 'Printer Rush- No mailing',
    frequency: 409_689,
    category: 'UC',
    details:
      'When there is an issue in an allowed application that requires correction or clarification in the Technology Center (TC), the Office of Publications (PUBS) returns the application to the TC as a Printer Query. In response, the Examiner may correct and/or initial various documents/forms to update the image file wrapper. This code indicates that it was not necessary to mail documents to the Applicant as part of the Printer Rush.',
  },
  {
    rank: 95,
    code: 'FLFEE' as const,
    description: 'Payment of additional filing fee/Preexam',
    frequency: 404_457,
    category: 'PE',
    details: 'Applicant has paid additional filing fees.',
  },
  {
    rank: 96,
    code: 'DKST' as const,
    description: 'Case Docketed or Redocketed to Examiner in GAU',
    frequency: 399_674,
    category: 'EX',
    details: 'Code was used for 6 months in 2001.',
  },
  {
    rank: 97,
    code: 'PUBTC' as const,
    description: 'Pubs Case Remand to TC',
    frequency: 390_952,
    category: 'UC',
    details:
      'An allowed application may be returned to the Technology Center (TC) for additional work or clarification.',
  },
  {
    rank: 98,
    code: 'A.NA' as const,
    description: 'Amendment after Notice of Allowance (Rule 312)',
    frequency: 385_749,
    category: 'AA',
    details:
      'When applicant files an amendment after the Notice of Allowance has been mailed but before the issue fee is paid, the amendment is not entered automatically. It may only be entered upon recommendation of a Primary Examiner. It will not be entered if it requires additional search or more than cursory review.',
  },
  {
    rank: 99,
    code: 'P210' as const,
    description: 'International Search Report Ready to be Mailed',
    frequency: 379_628,
    category: 'PCT',
    details:
      'This code refers to prior art searches conducted by USPTO under the Patent Cooperation Treaty (PCT). Certain PCT applications are assigned to the USPTO as the searching authority. In such cases examiners at USPTO conduct the prior art search and then forward the results of that search to the appropriate authority. This code indicates that the international search report is ready for mailing.',
  },
  {
    rank: 100,
    code: 'MP210' as const,
    description: 'Mail International Search Report',
    frequency: 379_552,
    category: 'PCT',
    details:
      'This code indicates that the International Search Report has been mailed to the appropriate authority.',
  },
]
